// src/pages/leads/CreateLeadPage.tsx
import AdminLayout from "../../layouts/AdminLayout";
import Breadcrumbs from "@/components/shared/nav/Breadcrumbs";

import CreateLeadForm from "@/components/leads/forms/CreateLeadForm";
import { useCreateLeadPage } from "./useCreateLeadPage";

export default function CreateLeadPage() {
  const { handleSubmit, handleCancel, submitting, errorMessage } =
    useCreateLeadPage();

  return (
    <AdminLayout>
      <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-xl font-semibold text-gray-900">Add Lead</h1>
          <div className="mt-1">
            <Breadcrumbs />
          </div>
        </div>
      </div>

      <div className="rounded-2xl border border-gray-200 bg-white px-4 py-5 sm:px-6 sm:py-6">
        <CreateLeadForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          submitting={submitting}
          errorMessage={errorMessage}
        />
      </div>
    </AdminLayout>
  );
}
